export const getS3CompletePathFromPreSigned = (url: string) => {
    if (!url) return "";

    return url.split("?")[0];
};
